export default __webpack_public_path__ + "static/media/IconDesc_PackagedWater.256.2fed85a7.png";